import type { AppState } from '@camelot/webview-utils'
import { defineWebView, getExpirationTime, refreshAuthToken } from '@camelot/webview-utils'
import { useAppStore } from '~/stores/appstore'

// Native pushes the token before app.vue mounts; without `window.app` the push dies as a
// ReferenceError that native drops silently.
export default defineNuxtPlugin(() => {
  defineWebView({
    setToken: (token: string): void => {
      if (token) {
        const expirationTime = getExpirationTime(token)
        if (expirationTime) {
          const tokenValidityInMs = (expirationTime * 1000) - Date.now()
          console.warn(`New token expires in ${tokenValidityInMs / 1000} seconds`)
          if (tokenValidityInMs < 20000) {
            refreshAuthToken(window)
          }
          else {
            setTimeout(() => refreshAuthToken(window), tokenValidityInMs - 20000)
          }
          if (tokenValidityInMs < 0) {
            console.warn('App injected an expired token, waiting for a new one')
          }
        }
      }
      const appStore = useAppStore()
      appStore.accessToken = token
    },
    updateAppStateParsed: (): AppState | undefined => {
      // Return undefined if app state is not needed or not available
      // This satisfies the TypeScript requirement while maintaining existing functionality
      return undefined
    },
  })
})
